import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { withStyles } from '@material-ui/core/styles';

import TabPanel from '../../../components/TabPanel';
import PatientProfile from './PatientProfile';
import PatientActiviy from './PatientActivity';

function PatientProfileModal(props) {
  const {
    open,
    patient,
    createPatient,
    updatePatient,
    onClose,
    classes: {
      modal,
      modalContent,
    },
  } = props;

  const [tabIndex, setTabIndex] = useState(0);

  const onSubmit = patient => {
    if (patient.existingPatient) {
      updatePatient(patient);
    } else {
      createPatient(patient);
    }
    onClose();
  };
  return (
    <div className="paddingZero">
    <Dialog
      fullWidth
      open={open}
      // disableBackdropClick
      onClose={onClose}
      classes={{ paper: modal }}
    >
      <DialogTitle>Patient Profile</DialogTitle>

      <DialogContent classes={{ root: modalContent }}>
        <AppBar position="static" color="default">
          <Tabs value={tabIndex} onChange={(_, newTabIndex) => setTabIndex(newTabIndex)}>
            <Tab label="Profile" />
            <Tab label="Activity" />
          </Tabs>
        </AppBar>

        {tabIndex === 0 && (
          <TabPanel>
            <PatientProfile
              patient={patient}
              onSubmit={onSubmit}
              onClose={onClose}
            />
          </TabPanel>
        )}

        {tabIndex === 1 && (
          <TabPanel className="patientTab">
            <PatientActiviy patient={patient} />
          </TabPanel>
        )}
      </DialogContent>
    </Dialog>
    </div>
  );
}

PatientProfileModal.propTypes = {
  patient: PropTypes.object,
  createPatient: PropTypes.func.isRequired,
  updatePatient: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

const styles = () => ({
  modal: {
    maxHeight: '600px',
  },
  modalContent: {
    overflow: 'visible',
  },
});

export default withStyles(styles)(PatientProfileModal);
